import { render, staticRenderFns } from "./articlemanagevenueadd.vue?vue&type=template&id=2c9d1983&scoped=true&"
import script from "./articlemanagevenueadd.vue?vue&type=script&lang=js&"
export * from "./articlemanagevenueadd.vue?vue&type=script&lang=js&"
import style0 from "./articlemanagevenueadd.vue?vue&type=style&index=0&id=2c9d1983&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9d1983",
  null
  
)

component.options.__file = "articlemanagevenueadd.vue"
export default component.exports